import { Row, Col, Modal, Form, Button, Spinner, OverlayTrigger, Popover } from "react-bootstrap"
import { useEffect, useState } from "react";
import { IAppState } from '../../../../../../redux/storeTypes';
import { connect, useDispatch } from "react-redux";
import Table from '../../../../../../components/Table';
import FormHeader from "../../../../../../components/layout/FormHeader";
import CurrencyInput from '../../../../../../components/currency/CurrencyInput';
import { CurrencyFormatter } from "../../../../../../components/Formatters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faCheck, faInfoCircle, faTimes, faTimesCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { updateOrderDetailsAction, updateShoppingCart } from "../../../../../../redux/actions/orderManagement";
import { sendSuccessToastAction } from "../../../../../../redux/actions/toast";
import { ItemStatusType, Order } from "../../../../../../models/Order";
import { DateFormatter } from "./ForsythSearchResults";
import _ from "lodash";

export const PAYABLE_METADATA_KEY = 'PayableOnline';
export const MINIMUM_PAYMENT_METADATA_KEY = 'MinimumPaymentAmount';

interface IRankinSearchResults {
    defendantNameLabel: string,
    citationNumberLabel: string,
    issueDateLabel: string,
    descriptionLabel: string,
    balanceDueLabel: string,
    paymentOptionsLabel: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText: string,
    minimumPaymentErrorText: string,
    observesWeekends: boolean,
    durationOfPendingHours: number,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    margin: string,
    padding: string,
    headerBackgroundColor: string,
    headerPadding: string,
    itemDetails: any,
    order?: any,
    shoppingCart?: any,
    isFetching: boolean,
    itemSearchDetails?: any
}

export const DEFENDANT_NAME_LABEL = 'Defendant Name';
export const CITATION_NUMBER_LABEL = 'Citation Number';
export const ISSUE_DATE_LABEL = 'Issue Date';
export const DESCRIPTION_LABEL = 'Description';
export const BALANCE_DUE_LABEL = 'Balance Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const MINIMUM_PARTIAL_PAYMENT_AMOUNT = 25;
export const MINIMUM_PAYMENT_TEXT = 'Minimum partial payment: {amount}';
export const MINIMUM_PAYMENT_ERROR_TEXT = 'Partial payments must be at least {amount}';
export const OBSERVES_WEEKENDS = false;
export const DURATION_OF_PENDING_HOURS = 24;
export const OVERLAY_TEXT = 'Your ticket is not currently payable online, please contact Rankin County or visit the office for further assistance.';
export const OVERLAY_BACKGROUND = '#fef1b5';
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const NO_MATCH_FOUND_TEXT = 'NO MATCH FOUND';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

export const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const RankinSearchResults = ({ defendantNameLabel, citationNumberLabel, issueDateLabel, descriptionLabel, balanceDueLabel, paymentOptionsLabel,
    minimumPartialPaymentAmount, minimumPaymentText, minimumPaymentErrorText, durationOfPendingHours, observesWeekends, itemSearchDetails, overlayText, overlayBackground, overlayTextColor,
    overlayIconColor, noMatchFoundText, margin, padding, headerBackgroundColor, headerPadding, itemDetails, shoppingCart, order, isFetching }: IRankinSearchResults) => {

    if (!defendantNameLabel) { defendantNameLabel = DEFENDANT_NAME_LABEL }
    if (!citationNumberLabel) { citationNumberLabel = CITATION_NUMBER_LABEL }
    if (!issueDateLabel) { issueDateLabel = ISSUE_DATE_LABEL }
    if (!descriptionLabel) { descriptionLabel = DESCRIPTION_LABEL }
    if (!balanceDueLabel) { balanceDueLabel = BALANCE_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (!minimumPartialPaymentAmount) { minimumPartialPaymentAmount = MINIMUM_PARTIAL_PAYMENT_AMOUNT }
    if (!minimumPaymentText) { minimumPaymentText = MINIMUM_PAYMENT_TEXT }
    if (!minimumPaymentErrorText) { minimumPaymentErrorText = MINIMUM_PAYMENT_ERROR_TEXT }
    if (!durationOfPendingHours) { durationOfPendingHours = DURATION_OF_PENDING_HOURS }
    if (!observesWeekends) { observesWeekends = OBSERVES_WEEKENDS }
    if (!overlayText) { overlayText = OVERLAY_TEXT }
    if (!overlayBackground) { overlayBackground = OVERLAY_BACKGROUND }
    if (!overlayTextColor) { overlayTextColor = OVERLAY_TEXT_COLOR }
    if (!overlayIconColor) { overlayIconColor = OVERLAY_ICON_COLOR }
    if (!noMatchFoundText) { noMatchFoundText = NO_MATCH_FOUND_TEXT }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }

    const [amount, setAmount] = useState<any>();
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState<any>({ option: 'full' });
    const [cartErrorMessage, setCartErrorMessage] = useState<string>('');

    const amountFormatter = (cell: any) => {
        return (<span>{formatter.format(cell)}</span>)
    }

    const paymentOptionsFormatter = (cell: any, row: any) => {
        const isViewable = row?.itemPaymentStatus != ItemStatusType.Pending && row?.metaData?.[PAYABLE_METADATA_KEY] != false;
        const infoOverlay = row?.itemPaymentStatus == ItemStatusType.Paid || row?.metaData?.[PAYABLE_METADATA_KEY] == false || row?.metaData?.TotalDue == 0
        if (isViewable) {
            return (
                <span>
                    <a
                        onClick={() => { setSelectedRow(row); setCartErrorMessage(''); setSelectedOption({ option: 'full' }); setAmount(null); setShowModal(true) }}
                    >
                        {paymentOptionsLabel}
                    </a>
                </span>
            )
        }
        else if (infoOverlay) {
            return (
                <span style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <OverlayTrigger trigger="click" rootClose placement="top" overlay={(
                        <Popover id="popover-positioned-top" style={{ backgroundColor: overlayBackground, color: overlayTextColor, minWidth: '400px' }}>
                            <Popover.Content>
                                <div style={{ display: 'flex', alignItems: 'center', columnGap: '8px', fontSize: 'medium' }}>
                                    <FontAwesomeIcon icon={faExclamationTriangle} color={overlayIconColor} className="btn-icon" />
                                {overlayText}
                                </div>
                            </Popover.Content>
                        </Popover>
                    )}>
                        <FontAwesomeIcon icon={faInfoCircle} className="btn-icon" style={{ color: "#6495ed", cursor: 'pointer' }} />
                    </OverlayTrigger>
                </span>
            )
        }
    }

    const statusFormatter = (cell: any, row: any) => {
        const statusValue = row?.itemPaymentStatus == ItemStatusType.Paid ? 'Paid' : row?.itemPaymentStatus == ItemStatusType.Pending ? 'Pending' : 'Unpaid';
        let color: string = "orange";
        if (statusValue === 'Paid') { color = "#52C41A" }
        if (statusValue === 'Pending') { color = "#f5b759" }
        if (statusValue === 'Unpaid') { color = "#F5222D" }
        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon icon={statusValue === 'Paid' ? faCheck : statusValue === 'Pending' ? faInfoCircle : faTimes} className="btn-icon" style={{ color: `${color}` }} />
                {statusValue}
            </span>
        )
    }

    const initialColumns = [{
        dataField: 'metaData.DefendantName',
        text: defendantNameLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'metaData.CitationNumber',
        text: citationNumberLabel,
        editable: false,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'metaData.IssueDate',
        text: issueDateLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
        formatter: DateFormatter,
    }, {
        dataField: 'metaData.FineDescription',
        text: descriptionLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
    }, {
        dataField: 'metaData.TotalDue',
        text: balanceDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: amountFormatter,
        sort: true,
    }, {
        dataField: 'itemPaymentStatus',
        text: 'Status',
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        sort: true,
        formatter: statusFormatter,
    }, {
        dataField: 'metaData.ReferenceNumber',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
        editable: false,
        formatter: paymentOptionsFormatter
    }];

    const [columns, setColumns] = useState<any>(initialColumns);
    const [data, setData] = useState<any>([]);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [showModal, setShowModal] = useState<boolean>(false);

    const effectiveMinimumPayment = Number(selectedRow?.metaData?.[MINIMUM_PAYMENT_METADATA_KEY]) || minimumPartialPaymentAmount;
    const withMinimumAmount = (text: string) => text.split('{amount}').join(formatter.format(effectiveMinimumPayment));

    const mappingDetails = [
        { heading: citationNumberLabel, value: selectedRow?.metaData?.CitationNumber },
        { heading: defendantNameLabel, value: selectedRow?.metaData?.DefendantName },
        { heading: issueDateLabel, value: DateFormatter(selectedRow?.metaData?.IssueDate, selectedRow) },
        { heading: descriptionLabel, value: selectedRow?.metaData?.FineDescription },
        { heading: balanceDueLabel, value: CurrencyFormatter(selectedRow?.metaData?.TotalDue) },
    ]

    const handleRadioSelect = (e: any) => {
        setCartErrorMessage('');
        setSelectedOption({ option: e.target.id });
        setAmount(null)
    }

    const partialAmountChange = (value: any) => {
        if (value > selectedRow?.metaData?.TotalDue) {
            setCartErrorMessage('Amounts cannot be greater than total due')
            setAmount(null)
            return
        }
        if (value > 0 && value < effectiveMinimumPayment) {
            setCartErrorMessage(withMinimumAmount(minimumPaymentErrorText))
            setAmount(value)
            return
        }
        setCartErrorMessage('')
        setAmount(value)
    }

    useEffect(() => {
        setData(itemDetails ?? []);
    }, [itemDetails])

    const hasSearched = itemSearchDetails != null;

    const renderTable = () => {
        if (isFetching) {
            return (<div style={{ textAlign: 'center' }} ><Spinner animation="border" /> </div>);
        }
        else if (data.length === 0 && hasSearched) {
            return (<div>{noMatchFoundText}</div>)
        }
        else if (data.length === 0) {
            return (<div>Please do a search to find the citation you are looking for.</div>)
        } else {
            return (
                <>
                    <Table
                        keyField="msbId"
                        data={data}
                        remote={false}
                        columns={columns}
                        sizePerPage={5}
                    />
                </>);
        }
    };

    const inCart = shoppingCart?.some((cart: any) => cart?.id === selectedRow?.metaData?.ReferenceNumber);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const shoppingCartObject = [
            {
                defendantName: selectedRow?.metaData?.DefendantName,
                citationNumber: selectedRow?.metaData?.CitationNumber,
                issueDate: selectedRow?.metaData?.IssueDate,
                description: selectedRow?.metaData?.FineDescription,
                id: selectedRow?.metaData?.ReferenceNumber,
                paymentAmount: selectedOption?.option === 'partial' ? _.toNumber(amount) : Number(selectedRow?.metaData?.TotalDue),
            }];
        const OrderLinesObject = [
            {
                accountNumber: selectedRow?.metaData?.CitationNumber,
                itemReferenceNumber: selectedRow?.metaData?.ReferenceNumber,
                quantity: 1,
                unitPrice: selectedOption?.option === 'partial' ? _.toNumber(amount) : Number(selectedRow?.metaData?.TotalDue),
                itemMetadata: {
                    uiReferenceId: selectedRow?.metaData?.ReferenceNumber,
                    statusUpdate: true,
                    itemMsbid: selectedRow?.msbId,
                    observesWeekends: observesWeekends,
                    durationOfPendingHours: durationOfPendingHours,
                    CaseNumber: selectedRow?.metaData?.CaseNumber,
                    CitationNumber: selectedRow?.metaData?.CitationNumber
                },
                itemName: selectedRow?.metaData?.CitationNumber,
            }];
        if (order) {
            const updatedOrderLines = order?.orderLines.filter((orderLine: any) => !OrderLinesObject.some((selected: any) => orderLine?.itemMetadata?.uiReferenceId === selected?.itemMetadata?.uiReferenceId)).concat(OrderLinesObject);
            const updatedShoppingCart = shoppingCart.filter((cart: any) => !shoppingCartObject.some((selected: any) => cart?.id === selected?.id)).concat(shoppingCartObject);
            order.methodName = "Sale";
            order.orderLines = updatedOrderLines;
            dispatch(updateShoppingCart(updatedShoppingCart, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(order, 'actionToken'));
        }
        else {
            let _order = new Order();
            _order.methodName = "Sale";
            _order.orderLines = OrderLinesObject;
            dispatch(updateShoppingCart(shoppingCartObject, 'shoppingCartActionToken'));
            dispatch(updateOrderDetailsAction(_order, 'actionToken'));
        }
        dispatch(sendSuccessToastAction('Added to cart'))
        setShowModal(false);
    }

    return (

        <div style={{ margin: margin, padding: padding }}>
            <Row><Col>{renderTable()}</Col></Row>
            <Modal show={showModal} size={'lg'} backdrop="static" onHide={() => setShowModal(false)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    <FormHeader title="Citation Details" description={"Below are the selected citation details"} />
                    <Form.Group controlId="printTerminal" >
                        <>
                            {Object.entries(mappingDetails).map(
                                ([index, selectedArray]: any) => {
                                    return (
                                        <div key={index} className="neric_details_row">
                                            <h3>{selectedArray.heading}</h3>
                                            <span>{selectedArray.value}</span>
                                        </div>
                                    )
                                }
                            )}
                        </>
                    </Form.Group>
                    <hr />
                    {!inCart ?
                        <>
                            <FormHeader title="Payment Options" description={"Please select the following payment options"} />
                            <Form.Group controlId="paymentOptions">
                                <div className='stCharles_cart'>
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='full'
                                                onChange={handleRadioSelect}
                                                checked={selectedOption?.option === 'full'}
                                            />
                                            Total Due
                                        </label>
                                        <span className='box_span'>{formatter.format(Number(selectedRow?.metaData?.TotalDue))}</span>
                                    </div>
                                    <br />
                                    <div className='box'>
                                        <label>
                                            <input
                                                type='radio'
                                                name='paymentOption'
                                                className='neric_input'
                                                id='partial'
                                                onChange={(e) => setSelectedOption({ option: `${e.target.id}` })}
                                                checked={selectedOption?.option === 'partial'}
                                            />Payment Amount
                                        </label>
                                        <Form.Group controlId="amount" className='box_span'>
                                            <CurrencyInput
                                                required
                                                className="form-control"
                                                id="summaryAmount"
                                                name="summaryAmount"
                                                placeholder="$ 0.00"
                                                maxLength={10}
                                                decimalsLimit={2}
                                                prefix="$ "
                                                disabled={selectedOption?.option != 'partial'}
                                                value={amount}
                                                onValueChange={(value: any) => partialAmountChange(value)}
                                            />
                                        </Form.Group>
                                        {selectedOption?.option === 'partial' &&
                                            <div style={{ fontSize: 'smaller', color: '#414141' }}>
                                                {withMinimumAmount(minimumPaymentText)}
                                            </div>
                                        }
                                        {cartErrorMessage && selectedOption?.option === 'partial' &&
                                            <div role="alert" id="paymentErrorBox" style={{ color: 'red' }}>
                                                <FontAwesomeIcon icon={faTimesCircle} color='red' /> {cartErrorMessage}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form.Group>
                        </>
                        :
                        <div className="stCharles-accordion accordion">
                            <div className='card'>
                                <div className='agreement_toggle_header card-header' style={{ justifyContent: 'center' }}>
                                    <FontAwesomeIcon color='green' icon={faCartPlus} />Added to cart
                                </div>
                            </div>
                        </div>
                    }
                    <Form.Group className="form-footer">
                        <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Close</Button>
                        <Button type="submit"
                            disabled={inCart || (selectedOption?.option == 'partial' && (amount == undefined || amount == 0 || amount > selectedRow?.metaData?.TotalDue || amount < effectiveMinimumPayment)) || selectedRow?.metaData?.TotalDue == 0} onClick={(e) => handleSubmit(e)}
                        >
                            {`Add to cart`}
                        </Button>
                    </Form.Group>
                </Modal.Body>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state: IAppState) => {
    return {
        isFetching: state.account.isFetching,
        itemDetails: state.account.itemDetails,
        shoppingCart: state.orderManagement.shoppingCart,
        order: state.orderManagement.order,
        itemSearchDetails: state.orderManagement.itemSearchDetails
    };
};

export default connect(mapStateToProps)(RankinSearchResults);
